import { InternalAxiosRequestConfig } from 'axios'
import humps from 'humps'

export const decamelizeKeysInterceptor = (
  config: InternalAxiosRequestConfig
) => {
  if (config.data) {
    config.data = humps.decamelizeKeys(config.data)
  }

  if (config.params) {
    config.params = humps.decamelizeKeys(config.params)
  }

  return config
}
